import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, RefreshCw, Package } from "lucide-react";
import { toast } from "sonner";
import { Rail } from "../components/Rail";
import api, { formatRp, apiError } from "../lib/api";
import { Field, inputCls, btnMint, btnGhost } from "../lib/ui";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";

const EMPTY = { code: "", name: "", price: "", description: "", image_url: "", active: true };

export default function Products() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);
  const load = () => api.get("/products").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      const body = { ...modal, price: parseFloat(modal.price) };
      if (modal.id) await api.put(`/products/${modal.id}`, body);
      else await api.post("/products", body);
      toast.success("Produk disimpan, katalog AI diperbarui");
      setModal(null);
      load();
    } catch (err) { toast.error(apiError(err)); }
  };

  const del = async (id) => {
    await api.delete(`/products/${id}`);
    toast.success("Produk dihapus");
    load();
  };

  const reindex = async () => {
    await api.post("/catalog/reindex");
    toast.success("Katalog AI berhasil di-index ulang");
  };

  return (
    <div className="flex h-screen bg-ink text-paper">
      <Rail />
      <main className="flex-1 overflow-y-auto">
        <header className="sticky top-0 z-10 flex items-center justify-between border-b border-white/5 bg-ink/80 px-8 py-5 backdrop-blur-md">
          <div>
            <h1 className="text-xl font-semibold">Produk</h1>
            <p className="text-sm text-muted">Katalog yang dilihat AI saat membalas chat</p>
          </div>
          <div className="flex gap-3">
            <button data-testid="products-reindex-btn" onClick={reindex} className={btnGhost}><RefreshCw size={14} /> Re-index</button>
            <button data-testid="products-add-btn" onClick={() => setModal({ ...EMPTY })} className={btnMint}><Plus size={15} /> Tambah Produk</button>
          </div>
        </header>
        <div className="grid gap-4 p-8 sm:grid-cols-2 xl:grid-cols-3" data-testid="products-grid">
          {items.map((p) => (
            <div key={p.id} className="rounded-2xl border border-white/5 bg-panel p-4 transition-colors hover:border-white/15">
              {p.image_url ? (
                <img src={p.image_url} alt={p.name} className="h-36 w-full rounded-xl object-cover" />
              ) : (
                <div className="flex h-36 w-full items-center justify-center rounded-xl bg-panel2"><Package className="text-faint" /></div>
              )}
              <div className="mt-3 flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <p className="truncate font-semibold">{p.name}</p>
                  <span className="rounded bg-white/5 px-1.5 py-0.5 font-mono text-[10px] text-faint">{p.code}</span>
                </div>
                <p className="shrink-0 font-mono text-mint">{formatRp(p.price)}</p>
              </div>
              <p className="mt-2 line-clamp-2 text-xs text-muted">{p.description}</p>
              <div className="mt-3 flex justify-end gap-2">
                <button data-testid={`product-edit-${p.code}`} onClick={() => setModal({ ...p })} className="rounded-lg p-2 text-faint transition-colors hover:bg-white/5 hover:text-paper"><Pencil size={14} /></button>
                <button data-testid={`product-delete-${p.code}`} onClick={() => del(p.id)} className="rounded-lg p-2 text-faint transition-colors hover:bg-white/5 hover:text-red-400"><Trash2 size={14} /></button>
              </div>
            </div>
          ))}
          {!items.length && <p className="text-sm text-faint">Belum ada produk. Tambahkan produk pertama Anda.</p>}
        </div>
      </main>

      <Dialog open={!!modal} onOpenChange={(o) => !o && setModal(null)}>
        <DialogContent className="border-white/10 bg-panel2 text-paper sm:rounded-2xl">
          <DialogHeader><DialogTitle>{modal?.id ? "Edit Produk" : "Tambah Produk"}</DialogTitle></DialogHeader>
          {modal && (
            <form onSubmit={save} className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <Field label="Kode"><input data-testid="product-code-input" className={inputCls} required value={modal.code} onChange={(e) => setModal({ ...modal, code: e.target.value.toUpperCase() })} /></Field>
                <Field label="Harga (Rp)"><input data-testid="product-price-input" type="number" className={inputCls} required value={modal.price} onChange={(e) => setModal({ ...modal, price: e.target.value })} /></Field>
              </div>
              <Field label="Nama"><input data-testid="product-name-input" className={inputCls} required value={modal.name} onChange={(e) => setModal({ ...modal, name: e.target.value })} /></Field>
              <Field label="Deskripsi"><textarea data-testid="product-desc-input" rows={3} className={inputCls} value={modal.description} onChange={(e) => setModal({ ...modal, description: e.target.value })} /></Field>
              <Field label="URL Gambar"><input data-testid="product-image-input" className={inputCls} value={modal.image_url} onChange={(e) => setModal({ ...modal, image_url: e.target.value })} /></Field>
              <button data-testid="product-save-btn" className={`${btnMint} w-full`}>Simpan</button>
            </form>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
